// extracted by mini-css-extract-plugin
export default {"page":"style_page__rIjMc","body":"style_body__MRRzk","content":"style_content__sbV+5"};